module.exports = __webpack_public_path__ + "img/bankheader.fc26741a.png";